<template>
  <modal-default modal-title="Adicionar Atividade" modal-id="modalSetActiveFunil">
    <datapicker-global variable-name="scheduling" have-range-days-max="false" col="7" range-days-init="0"
                       label="Data inicial - Prazo final" is-required="true"/>

    <input-select @selectedOptionString="value => dataSend.responsible = value" col="5" :options="responsiblesOptions"
                  label="Responsável" nameOnlyString="true" is-required="true" :inputError="dataError.responsible"/>

    <input-select @selectedOptionNumber="value => dataSend.activity = value" :value-is-number="true" col="12"
                  :options="activityOptions" label="Atividade" is-required="true"
                  :inputError="dataError.activity"/>

    <input-textarea @contentTextarea="value => dataSend.description = value" col="12" placeholder="Digite"
                    label="Comentários ou anotações sobre essa atividade"/>

    <btn-search :loading="loadingSend" haveLoading="true" @emit-click="sendActive()" label="Enviar" whichSide="right"/>
  </modal-default>
</template>

<script>
import datepicker from 'vuejs-datepicker';
import DatapickerGlobal from "../components/inputs/datapickerGlobal.vue";
import ModalDefault from "../components/modals/modalDefault.vue";
import InputSelect from "../components/inputs/inputSelect.vue";
import InputTextarea from "../components/inputs/inputTextarea.vue";
import BtnSearch from "../components/buttons/btnSearch.vue";
import {REQUEST_SERVICE, UTIL_SERVICE} from "../../../requestConfig";
import {CREATE_ACTIVE_USER, GET_BUSINESS_TASK_TYPES} from "../../../urlConfig";
import swal from "sweetalert";
import {ALERT_SERVICE} from "../../../msgAlertService";

export default {
  name: "modalSetActiveFunil",
  props: {
    dataModal: {
      default: '',
    },
    responsibles: {
      default: '',
    },
    runFunction: {
      type: Function,
    },
  },
  components: {
    BtnSearch,
    InputTextarea,
    InputSelect,
    ModalDefault,
    DatapickerGlobal,
    datepicker
  },
  data() {
    return {
      loadingSend: false,
      dataSend: {
        responsible: '',
        activity: '',
        description: '',
      },
      dataError: {
        responsible: false,
        activity: false,
      },
      responsiblesOptions: [
        'Selecione',
      ],
      activityOptions: ''
    }
  },
  created() {
    REQUEST_SERVICE.get(GET_BUSINESS_TASK_TYPES).then((response) => {
      UTIL_SERVICE.console("RESULT GET_BUSINESS_TASK_TYPES:", response.data);

      this.activityOptions = response.data

    }).catch((reason) => {
      ALERT_SERVICE.showMsgError(reason.response.data.erros);
    });
  },
  watch: {
    responsibles: function (newValue, oldValue) {
      this.responsiblesOptions.push(...newValue)
    }
  },
  methods: {
    sendActive() {
      this.dataError = {
        responsible: false,
        activity: false,
      }

      let obj = {}

      let validateSelect = ['', 'Selecione']

      if (validateSelect.includes(this.dataSend.responsible) || !this.dataSend.activity) {
        if (validateSelect.includes(this.dataSend.responsible)) {
          this.dataError.responsible = true;
        }

        if (!this.dataSend.activity) {
          this.dataError.activity = true;
        }

      } else {
        this.loadingSend = true;

        obj = {
          taskDateInit: this.$route.params.schedulingInit,
          taskDateEnd: this.$route.params.schedulingEnd,
          toWho: this.dataSend.responsible,
          description: this.dataSend.description,
          businessTaskType: this.dataSend.activity,
          random: Math.floor(Math.random() * 500),
          pipelineId: this.$route.params.idPipe,
          pipelineBusinessId: this.$route.params.idBusiness,
          businessTaskStatus: 1,
          whoCreatedId: this.$route.params.userInfo.id
        }

        UTIL_SERVICE.console("Data send: ", obj);
        REQUEST_SERVICE.post(CREATE_ACTIVE_USER, obj).then((response) => {
          UTIL_SERVICE.console("RESULT CREATE_ACTIVE_USER:", response.data);

          swal("Aviso", response.data, "success");

          this.loadingSend = false;
          $('#modalSetActiveFunil').modal('toggle');
          this.runFunction();
        }).catch((reason) => {
          this.loadingSend = false;
          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        });
      }
    },
  }
}
</script>

<style lang="scss">

.swal-overlay {
  z-index: 99999;
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalSetActiveFunil.vue